import { memo } from 'react';

type Opts = { width?: number; height?: number; margin?: number | string; dataTestId?: string };

const createIcon = (src: string, opts: number | Opts = 24) => {
  const { width = 24, height = width, margin, dataTestId } =
    typeof opts === 'number' ? ({ width: opts } as Opts) : opts;
  return (
    <>
      <img data-testid={dataTestId} src={src} alt="" />
      <style jsx>{`
        img {
          width: ${width}px;
          height: ${height}px;
          ${margin ? `margin: ${margin} ;` : null}
        }
      `}</style>
    </>
  );
};

export const CloseIcon = memo((opts: Opts) => createIcon('/icons/close.svg', opts));

export const BreadCrumbArrowIcon = memo((opts: Opts) => createIcon('/icons/breadcrumb-arrow.svg', opts));

export const CategoryIcon = memo((opts: Opts) => createIcon('/icons/category.svg', opts));

export const MapPointerIcon = memo((opts: Opts) => createIcon('/icons/map-pointer.svg', opts));

export const MapPointerWhiteIcon = memo((opts: Opts) => createIcon('/icons/map-pointer-white.svg', opts));

export const OccupationPaintIcon = memo((opts: Opts) => createIcon('/icons/occupation-paint.svg', opts));

export const ArrowForwardIcon = memo((opts: Opts) => createIcon('/icons/arrow-forward.svg', opts));

export const ArrowDownIcon = memo((opts: Opts) => createIcon('/icons/arrow-down.svg', opts));

export const ArrowUpIcon = memo((opts: Opts) => createIcon('/icons/arrow-up.svg', opts));

export const ArrowBackIcon = memo((opts: Opts) => createIcon('/icons/arrow-back.svg', opts));

export const FilterIcon = memo((opts: Opts) => createIcon('/icons/filter.svg', opts));

export const CheckboxCheckIcon = memo((opts: Opts) => createIcon('/icons/checkbox-check.svg', opts));

export const MarupochiIcon = memo((opts: Opts) => createIcon('/icons/marupochi.svg', opts));

export const RatingStarUnchecked = memo((opts: Opts) => createIcon('/icons/rating-star-unchecked.svg', opts));

export const RatingStarChecked = memo((opts: Opts) => createIcon('/icons/rating-star-checked.svg', opts));

export const UserProfileIcon = memo((opts: Opts) => createIcon('/icons/user-profile.svg', opts));

export const LogoutIcon = memo((opts: Opts) => createIcon('/icons/logout.svg', opts));

export const TrainIcon = memo((opts: Opts) => createIcon('/icons/train.svg', opts));

export const CheckSmallIcon = memo((opts: Opts) => createIcon('/icons/check-small.svg', opts));

export const SearchGrassIcon = memo((opts: Opts) => createIcon('/icons/top-search.svg', opts));

export const SpinnerIcon = memo((opts: Opts) => createIcon('/icons/spinner.svg', opts));

// 介護向け
export const WorkTimeIcon = memo((opts: Opts) => createIcon('/icons/care-clock.svg', opts));
export const WorkAddressIcon = memo((opts: Opts) => createIcon('/icons/care-address.svg', opts));
export const WorkTaskIcon = memo((opts: Opts) => createIcon('/icons/care-task.svg', opts));
export const FavoriteIcon = memo((opts: Opts) => createIcon('/icons/favorite.svg', opts));
export const FavoriteWhiteIcon = memo((opts: Opts) => createIcon('/icons/favorite-white.svg', opts));
export const FavoritedIcon = memo((opts: Opts) => createIcon('/icons/favorited.svg', opts));
export const ClockIcon = memo((opts: Opts) => createIcon('/icons/clock.svg', opts));
export const MapIcon = memo((opts: Opts) => createIcon('/icons/map.svg', opts));
export const IdentityVerifiedIcon = memo((opts: Opts) => createIcon('/icons/identity-verified.svg', opts));
export const UnIdentityVerifiedIcon = memo((opts: Opts) => createIcon('/icons/unidentity-verified.svg', opts));
export const NotificationOffIcon = memo((opts: Opts) => createIcon('/icons/notification-off.svg', opts));
export const NotificationOnIcon = memo((opts: Opts) => createIcon('/icons/notification-on.svg', opts));
export const LicenseEmpty = memo((opts: Opts) => createIcon('/icons/license-empty.svg', opts));
export const RegisterLicense = memo((opts: Opts) => createIcon('/icons/register-license.svg', opts));
export const RecruitmentClosedLabel = memo((opts: Opts) => createIcon('/icons/recruitment-closed-label.svg', opts));
export const AppAppealOne = memo((opts: Opts) => createIcon('/icons/lp-app-appeal-number-one.svg', opts));
export const AppAppealTwo = memo((opts: Opts) => createIcon('/icons/lp-app-appeal-number-two.svg', opts));
export const AppAppealThree = memo((opts: Opts) => createIcon('/icons/lp-app-appeal-number-three.svg', opts));
export const AppAppealFour = memo((opts: Opts) => createIcon('/icons/lp-app-appeal-number-four.svg', opts));
export const AppAppealFive = memo((opts: Opts) => createIcon('/icons/lp-app-appeal-number-five.svg', opts));
export const CheckCircle = memo((opts: Opts) => createIcon('/icons/lp-check-circle.svg', opts));

export const TalkOrWatchingIcon = memo((opts: Opts) => createIcon('/icons/talk-or-watching.svg', opts));
export const DriverIcon = memo((opts: Opts) => createIcon('/icons/driver.svg', opts));
export const BathAssistIcon = memo((opts: Opts) => createIcon('/icons/bath-assist.svg', opts));
export const LongTermAssistIcon = memo((opts: Opts) => createIcon('/icons/long-term-assist.svg', opts));
export const MedicationManagementIcon = memo((opts: Opts) => createIcon('/icons/medication-management.svg', opts));
export const MedicalCheckupIcon = memo((opts: Opts) => createIcon('/icons/medical-checkup.svg', opts));
export const NursingWorkIcon = memo((opts: Opts) => createIcon('/icons/nursing-work.svg', opts));
export const RecreationIcon = memo((opts: Opts) => createIcon('/icons/recreation.svg', opts));
export const VitalCheckIcon = memo((opts: Opts) => createIcon('/icons/vital-check.svg', opts));
export const InspectionAssistanceIcon = memo((opts: Opts) => createIcon('/icons/inspection-assistance.svg', opts));
export const QuestionIcon = memo((opts: Opts) => createIcon('/icons/question.svg', opts));
export const HeaderMenuIcon = memo((opts: Opts) => createIcon('/icons/header-menu.svg', opts));
export const HeaderMypageIcon = memo((opts: Opts) => createIcon('/icons/header-mypage.svg', opts));
export const HeaderFavoriteIcon = memo((opts: Opts) => createIcon('/icons/header-favorite.svg', opts));
export const HeaderMessageIcon = memo((opts: Opts) => createIcon('/icons/header-message.svg', opts));
export const HeaderScheduleIcon = memo((opts: Opts) => createIcon('/icons/header-schedule.svg', opts));
export const PolygonBottomIcon = memo((opts: Opts) => createIcon('/icons/polygon-bottom.svg', opts));
export const NoScheduleIcon = memo((opts: Opts) => createIcon('/icons/no-schedule.svg', opts));
export const CheckLightGreenIcon = memo((opts: Opts) => createIcon('/icons/check-light-green.svg', opts));
export const CalendarIcon = memo((opts: Opts) => createIcon('/icons/calendar.svg', opts));
export const DocumentIcon = memo((opts: Opts) => createIcon('/icons/document.svg', opts));
export const SortIcon = memo((opts: Opts) => createIcon('/icons/sort-icon.svg', opts));

export const ReviewHintsIcon = memo((opts: Opts) => createIcon('/icons/review-hints.svg', opts));

//react-day-picker
export const DayPickerBackIcon = memo((opts: Opts) => createIcon('/icons/day-picker-back.svg', opts));
export const DayPickerForwardIcon = memo((opts: Opts) => createIcon('/icons/day-picker-forward.svg', opts));
